import React from 'react';
import { Box, Grid, KeyValue, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../style';
import { stringToSemanticDisplay } from '../../../../../utils/DateUtils';

interface CandidateDetailsProps {
  certificateNo?: string;
  dateAttained?: string;
  motherTongueLanguage: string;
}

const CandidateDetails = ({ candidateDetails }: { candidateDetails: CandidateDetailsProps }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { certificateNo, dateAttained, motherTongueLanguage } = candidateDetails;

  return (
    <Box className={`${classes.container} ${classes.documentBadgeContainer}`}>
      <Typography variant="h3" className={classes.subheader}>
        {t('exam->>candidateDetails.title')}
      </Typography>
      {certificateNo && (
        <Grid container spacing={2}>
          <Grid md={12} xs={12}>
            <KeyValue
              keyText={t('exam->>candidateDetails.SGBirthCertNo')}
              valueText={certificateNo || '-'}
            />
          </Grid>
        </Grid>
      )}
      {dateAttained && (
        <Grid container spacing={2}>
          <Grid md={12} xs={12}>
            <KeyValue
              keyText={t('exam->>candidateDetails.selectDate')}
              valueText={stringToSemanticDisplay(dateAttained) || '-'}
            />
          </Grid>
        </Grid>
      )}
      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue
            keyText={t('exam->>candidateDetails.motherTongue')}
            valueText={motherTongueLanguage || '-'}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CandidateDetails;
